import React, { useState } from 'react';
import { QueryResultDialog } from './QueryResultDialog';
import { CollapsibleQueryResult, QueryResultBaseProps } from './CollapsibleQueryResult';

export interface WorkbenchQueryResultContainerProps extends QueryResultBaseProps {
  queryResultDialogClassName?: string;
}

export function WorkbenchQueryResultContainer(props: WorkbenchQueryResultContainerProps) {
  const [ isExpandedView, setIsExpandedView ] = useState(false);

  const toggleExpandedView = () => {
    setIsExpandedView((state) => !state);
  };

  const {
    className,
    queryResultDialogClassName,
    ...dialogProps
  } = props;

  return (<>
    <CollapsibleQueryResult
      {...props}
      toggleExpandedView={toggleExpandedView}
    />

    <QueryResultDialog
      className={queryResultDialogClassName}
      {...dialogProps}
      open={isExpandedView}
      toggleExpandedView={toggleExpandedView}
    />
  </>);
}
